import React from 'react';
import { Box, Container, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

function AuthLayout({ children, ...props }) {
    const theme = useTheme();
  
  return (
          <Box sx={{ display: 'flex' }}>
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  // marginLeft: isPermanentOpen ? 0 : '16px',
                  // marginBottom: 4,
                  // marginTop: 1,
                  maxWidth: '100vw',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    maxWidth: 420,
                    // height: '100vh',
                    // overflowY: 'auto',
                    bgcolor: '#F8F9FB',
                    display: 'flex',
                    border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                    gap: 20,
                    flexDirection: 'column',
                    // justifyContent: 'flex-start',
                  }}
                >
                  <Container maxWidth="xxl">{children}</Container>
                </Box>
              </Box>
            </Box>
  );
}

export default AuthLayout;
